import { Fragment, useState, useEffect, useContext } from 'react'
import { Listbox} from '@headlessui/react'
import { ProductsContext } from '../context/products.context';

export default function ListWorkforce( {changeFilter} ) {
  const { workforce, workforceMenu } = useContext(ProductsContext)
   const [currentFilter, setCurrentFilter] = useState(workforce, workforceMenu);
  const [filterList, setFilterList] = useState([]);
  // const { document: documents } = useDocument("menuItems", "workforceMenuItem");

  useEffect(() => {
    let preFilterList = []
    const fetchFilter = async () => {
    if (workforceMenu) {workforceMenu.listWDA.forEach((doc) => {
      return (preFilterList.push({workforceValue: doc.WDA_Area, workforceCounty: doc.WDA_County}))

    });
  }};
  fetchFilter();
  setFilterList([ ...new Set(preFilterList.map( (w) => (w)))]);

}, [workforceMenu]);



  const handleClick = (newFilter) => {
    setCurrentFilter(newFilter);
    changeFilter(newFilter);
  };
  return (

    <div className="w-[220px] col-start-4 col-span-2 relative inline-block z-30">
      <Listbox value={currentFilter} onChange={handleClick}>
        <div className="relative">
          <Listbox.Button className="relative w-full py-2 pl-2 pr-10 text-left text-sm hover:text-blue-600  bg-zinc-100 rounded-md outline outline-gray-300 outline-1  outline-offset-2 focus-visible:ring-2 focus-visible:ring-indigo-200 focus-visible:ring-opacity-75">
            <span className="block truncate">Change Workforce Area</span>
            <span className="absolute inset-y-0 right-0 flex items-center pr-2 pointer-events-none">
              <div
                className="w-5 h-5 text-gray-400"
                aria-hidden="true"
              ><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="size-6">
              <path fillRule="evenodd" d="M11.47 4.72a.75.75 0 0 1 1.06 0l3.75 3.75a.75.75 0 0 1-1.06 1.06L12 6.31 8.78 9.53a.75.75 0 0 1-1.06-1.06l3.75-3.75Zm-3.75 9.75a.75.75 0 0 1 1.06 0L12 17.69l3.22-3.22a.75.75 0 1 1 1.06 1.06l-3.75 3.75a.75.75 0 0 1-1.06 0l-3.75-3.75a.75.75 0 0 1 0-1.06Z" clipRule="evenodd" />
            </svg>
            </div>
            </span>
          </Listbox.Button>
            <Listbox.Options className="absolute w-full py-1 mt-1 overflow-auto text-base bg-white rounded-md shadow-lg max-h-[500px] ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm">
            {filterList.length > 1 && filterList.map((f) => (
                <Listbox.Option
                  key={f.workforceCounty}
                  className={({ active }) =>
                    `cursor-default select-none relative py-1 pl-10 pr-4 ${
                      active ? 'text-indigo-900 bg-indigo-100' : 'text-gray-900'
                    }`
                  }
                  value={f.workforceValue}>

                    <>
                      <span
                        className="block truncate"
                      >
                        {f.workforceCounty}
                      </span>

                      {currentFilter === f.workforceValue  ? (
                        <span className="absolute inset-y-0 left-0 flex items-center pl-3 text-indigo-600">
                          <div className="w-4 h-4" aria-hidden="true"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="size-4">
  <path fillRule="evenodd" d="M19.916 4.626a.75.75 0 0 1 .208 1.04l-9 13.5a.75.75 0 0 1-1.154.114l-6-6a.75.75 0 0 1 1.06-1.06l5.353 5.353 8.493-12.74a.75.75 0 0 1 1.04-.207Z" clipRule="evenodd" />
</svg>
</div>
                        </span>
                      ) : null}

                    </>

                </Listbox.Option>
              ))}
            </Listbox.Options>

        </div>
      </Listbox>
    </div>
  )
}
